import React from 'react';
import { Scissors, Sparkles, Crown } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';

const SERVICES = [
  {
    title: 'Taglio Uomo',
    description: 'Taglio personalizzato studiato per valorizzare ogni volto e stile.',
    icon: Scissors,
    price: '23€'
  },
  {
    title: 'Modellatura',
    description: 'Definizione e styling della barba con prodotti professionali.',
    icon: Sparkles,
    price: '16€'
  },
  {
    title: 'Barba Classica Rasoio',
    description: 'Rasatura con rasoio a mano libera, sapone caldo e massaggio rigenerante.',
    icon: Sparkles,
    price: '20€'
  },
  {
    title: "Roger's Elite",
    description: 'Massaggio tonificante, panno caldo, scrub viso, acido ialuronico contorno occhi, colonia premium, massaggio collo e spalle, shampoo scrub, cuscino riscaldato cervicale + whisky o caffè.',
    icon: Crown,
    price: '25€'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 bg-black" data-testid="services-section">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <Badge className="bg-amber-500 text-black mb-4 px-4 py-1 text-sm">I NOSTRI SERVIZI</Badge>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Servizi <span className="text-amber-500">& Prezzi</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Ogni servizio è un'esperienza curata nei minimi dettagli
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={index} 
                className="bg-zinc-900 border-zinc-800 hover:border-amber-500 transition-all duration-300 hover:transform hover:scale-105 group"
                data-testid={`service-card-${index}`}
              >
                <CardContent className="p-8 text-center">
                  <div className="mb-4 group-hover:scale-110 transition-transform flex justify-center">
                    <IconComponent size={48} className="text-amber-500" />
                  </div>
                  <h3 className="text-xl font-serif font-bold mb-3 group-hover:text-amber-500 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed mb-4 text-base">
                    {service.description}
                  </p>
                  <div className="text-3xl font-serif font-bold text-amber-500">
                    {service.price}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
